import React, { useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./style.css";
import Story from "./Story";
import PropTypes from "prop-types";
import SliderButton from "./SliderButton";

const Stories = ({ storiesData }) => {
  let sliderRef = useRef(null);
  const [currIndex, setCurrIndex] = useState(0);
  const next = () => {
    sliderRef.slickNext();
  };
  const previous = () => {
    sliderRef.slickPrev();
  };
  const handleAfterChange = (currentSlide) => {
    setCurrIndex(currentSlide);
  };
  const settings = {
    dots: storiesData?.length > 1,
    infinite: false,
    autoplay: false,
    speed: 900,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    afterChange: handleAfterChange,
  };

  return (
    <div>
      <div id="slider_product_list" className="md:ml-[8vw] ml-0 mt-[-4vh]">
        <Slider
          {...settings}
          ref={(slider) => {
            sliderRef = slider;
          }}
        >
          {storiesData?.length > 0 &&
            storiesData?.map((item, index) => (
              <Story key={index} item={item} />
            ))}
        </Slider>
      </div>
      {storiesData?.length > 1 && 
      <div className="h-2">
        {storiesData?.map((item, index) =>
          index === currIndex ? (
            <div
              key={index}
              style={{ textAlign: "center" }}
              className="flex justify-between items-center relative md:top-[-20vw] top-[-110vw]"
            >
              {item?.arrow_button?.map((el, i) => (
                <SliderButton
                  key={i}
                  ind={i}
                  backgroundImg={el?.backgroundImg}
                  button_icon={el?.button_icon}
                  previous={previous}
                  next={next}
                />
              ))}
            </div>
          ) : null
        )}
      </div>
      }
    </div>
  );
};

Stories.propTypes = {
  storiesData: PropTypes.array,
};

export default Stories;
